/**
 * Service Analytics API
 * Tracking et statistiques de traffic
 */

import { api } from './api';
import type { LogVisitPayload, TrafficStats } from '../types/analytics';

const ANALYTICS_BASE = '/api/analytics';

/**
 * Logger une visite (public, no auth)
 */
export async function logVisit(payload: LogVisitPayload): Promise<{ id: string; timestamp: string }> {
  const response = await fetch(`${import.meta.env.VITE_API_URL}${ANALYTICS_BASE}/visit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    // Silent fail pour ne pas bloquer l'UX
    console.warn('Failed to log visit:', response.status);
    return { id: '', timestamp: '' };
  }

  return response.json();
}

/**
 * Récupérer les stats de traffic (admin only)
 */
export async function getTrafficStats(period: 'day' | 'week' | 'month' = 'week'): Promise<TrafficStats | null> {
  const response = await api.get<TrafficStats>(`${ANALYTICS_BASE}/stats?period=${period}`);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data ?? null;
}

/**
 * Récupérer les visites récentes (admin only, debug)
 */
export async function getRecentVisits(limit: number = 50): Promise<VisitEvent[]> {
  const response = await api.get<{ visits: VisitEvent[] }>(`${ANALYTICS_BASE}/recent?limit=${limit}`);
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data?.visits ?? [];
}

export interface VisitEvent {
  id: string;
  timestamp: string;
  sessionId: string;
  path: string;
  referrer?: string;
  userAgent?: string;
  deviceType: 'desktop' | 'mobile' | 'tablet';
  duration?: number;
}
